// Single CDN project image (project A)
export const PROJECT_A_IMG =
  "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6ab288342c80cdf1d5a673b7.webp";
